module.exports = __webpack_public_path__ + "static/media/cloud-loading.ddcc3d7b.svg";